<p-breadcrumb [model]="breadCrumbItems"></p-breadcrumb>

<br /><br />

<div class="p-grid p-jc-center">
  <div class="p-col-12 p-sm-12 p-md-11 p-xl-9">
    <div class="card card-w-title">
      <!--  DataView  -->
      <p-dataView
        [value]="tipos"
        layout="grid"
        [loading]="loading"
        emptyMessage="Sin resultados"
        [paginator]="false"
      >
        <!--   DataView items   -->
        <ng-template let-tipo pTemplate="gridItem">
          <div class="item-div p-col-12 p-sm-6 p-md-4 p-lg-3">
            <p-panel class="p-text-center grid-item" [header]="tipo.nombre">
              <a class="color-blue" [routerLink]="[tipo.codigo]">
                <img [src]="tipo.imagen" [alt]="tipo.nombre" />
              </a>
              <div>
                <p>{{ tipo.descripcion }}</p>
              </div>
              <div>
                <a class="color-blue" [routerLink]="[tipo.codigo]">Continuar</a>
              </div>
            </p-panel>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
</div>
